import {UI} from "../../../stem-core/src/ui/UIBase";

import {styleRule, StyleSheet} from "../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {Dispatcher} from "../../../stem-core/src/base/Dispatcher";
import {isSmallScreen} from "../../Utils";
import {Device} from "../../../stem-core/src/base/Device";
import {WidgetScrim} from "./WidgetScrim";
import {WidgetActiveRouteElement} from "./WidgetActiveRouteElement";
import {IndexExpanded} from "../pages/index-expanded/IndexExpanded";
import {DEFAULT_TRANSITION_TIME_MS} from "../../../blink-sdk/Constants";


export class WalletPopupStyle extends StyleSheet {
    transitionTime = DEFAULT_TRANSITION_TIME_MS;

    @styleRule
    popup = {
        borderRadius: () => isSmallScreen() && !Device.isLandscape() ? 0 : 12,
        background: this.themeProps.WALLET_GRADIENT_BACKGROUND,
        width: "100%",
        transition: this.transitionTime + "ms ease",
        position: "absolute",
        bottom: 0,
        transformOrigin: "bottom",
        zIndex: 3,
        opacity: 1,
        minWidth: 360,
        transform: "translateY(100%)",
        minHeight: this.themeProps.FIT_CONTENT,
        display: "flex",
        flexDirection: "column",
    };

    @styleRule
    visible = {
        height: "100%",
        transform: "translateY(0)",
    };

    @styleRule
    hidden = {
        opacity: 0,
    };

    @styleRule
    card = {
        minHeight: this.themeProps.FIT_CONTENT,
    }
}

export function WalletPopup(CardClass) {
    @registerStyle(WalletPopupStyle)
    class Popup extends WidgetActiveRouteElement {
        static instancesMap = new Map();
        visible = false;

        static getParentNode() {
            return IndexExpanded.instance.node;
        }

        extraNodeAttributes(attr) {
            super.extraNodeAttributes(attr);
            attr.addClass(this.styleSheet.popup);
            if (this.visible) {
                attr.addClass(this.styleSheet.visible);
            }
        }

        static show(options) {
            if (this.instancesMap.get(this.name)) {
                return;
            }
            this.instancesMap.set(this.name, this.create(this.getParentNode(), options));
        }

        static hide() {
            const instance = this.instancesMap.get(this.name);
            if (!instance) {
                return;
            }
            instance.hide();
        }

        static kill() {
            const instance = this.instancesMap.get(this.name);
            if (!instance) {
                return;
            }
            instance.hide(0);
        }

        hide(timeout) {
            if (timeout == null) {
                timeout = this.styleSheet.transitionTime;
            }
            this.scrim.hide(timeout);
            this.removeClass(this.styleSheet.visible);
            this.attachTimeout(() => this.destroyNode(), timeout);
            this.scrim = null;
            this.constructor.instancesMap.set(this.constructor.name, null);
            this.visible = false;
        }

        render() {
            if (!this.scrim) {
                this.scrim = WidgetScrim.create(this.constructor.getParentNode());
            }
            return <CardClass ref="card" className={this.styleSheet.card}/>;
        }

        computeHeight() {
            return this.card.computeHeight();
        }

        onMount() {
            super.onMount();
            this.attachTimeout(() => {
                this.visible = true;
                this.redraw();
            });
        }
    }

    return Popup;
}
